import { Scaling } from "./Scaling";
import { Logger, Utils } from "neo-common";
import { GameManager } from "../Managers/GameManager";
import { Communication } from "neo-games";
import { Symbol } from "../GameComponents/Symbol";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";

type GameModuleBaseResponse = Communication.Game.GameModuleBaseResponse;
type GameModuleFreespinResponse = Communication.Game.GameModuleFreespinResponse;
type GameModuleResponse = Communication.Game.GameModuleResponse;

type IWin = Communication.Game.IWin;

export class CustomUtils {
    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************
    public static readonly SymbolJ: number = 1;
    public static readonly SymbolQ: number = 2;
    public static readonly SymbolK: number = 3;
    public static readonly SymbolA: number = 4;
    public static readonly SymbolMap: number = 5;
    public static readonly SymbolLantern: number = 6;
    public static readonly SymbolChest: number = 7;
    public static readonly SymbolKnight: number = 8;
    public static readonly SymbolWizzard: number = 9;
    public static readonly SymbolKing: number = 10;
    public static readonly SymbolWild: number = 11;
    public static readonly SymbolWildExpand: number = 12;
    public static readonly SymbolWildCloning: number = 13;
    public static readonly SymbolWildMultiply: number = 14;
    public static readonly SymbolScatter: number = 15;

    public static readonly NudgeSymbols: Array<number> = [
        CustomUtils.SymbolKnight,
        CustomUtils.SymbolWizzard,
        CustomUtils.SymbolKing,
    ];

    public static readonly NudgeSymbolPartCount: number = 3;

    public static hasNudgeSymbols(): boolean {
        return this.getNudgeReelIndexes().length > 0;
    }

    public static hasNudgeSymbolsFS(): boolean {
        return this.getNudgeReelIndexesFS().length > 0;
    }

    public static getNudgeReelIndexes(): Array<number> {
        const reelIndexes: Array<number> = [];

        if (GameManager.baseResponse == null || GameManager.baseResponse.screen == null) {
            return reelIndexes;
        }

        for (let i = 0; i < GameManager.baseResponse.screen.reels.length; i++) {
            const transformData = GameManager.baseResponse.screen.reels[i].transform;

            if (transformData != null) {
                for (let j = 0; j < CustomUtils.NudgeSymbols.length; j++) {
                    if (
                        CustomUtils.getNudgeSymbolIndex(
                            transformData.length,
                            transformData,
                            CustomUtils.NudgeSymbols[j],
                        ) > -1
                    ) {
                        reelIndexes.push(i);
                        break;
                    }
                }
            }
        }

        return reelIndexes;
    }

    public static getNudgeReelIndexesFS(): Array<number> {
        const reelIndexes: Array<number> = [];

        if (GameManager.freespinsResponse == null || GameManager.freespinsResponse.screen == null) {
            return reelIndexes;
        }

        for (let i = 0; i < GameManager.freespinsResponse.screen.reels.length; i++) {
            const transformData = GameManager.freespinsResponse.screen.reels[i].transform;

            if (transformData != null) {
                for (let j = 0; j < CustomUtils.NudgeSymbols.length; j++) {
                    if (
                        CustomUtils.getNudgeSymbolIndex(
                            transformData.length,
                            transformData,
                            CustomUtils.NudgeSymbols[j],
                        ) > -1
                    ) {
                        reelIndexes.push(i);
                        break;
                    }
                }
            }
        }

        return reelIndexes;
    }

    public static getNudgeSymbolCount(
        visibleSymbolsCount: number,
        reelSymbols: Array<number>,
        symbolId: number,
    ): number {
        let count = 0;

        for (let i = 0; i < visibleSymbolsCount; i++) {
            if (reelSymbols[i] == symbolId) {
                count++;
            }
        }

        return count;
    }

    public static getNudgeSymbolIndex(
        visibleSymbolsCount: number,
        reelSymbols: Array<number>,
        symbolId: number,
    ): number {
        for (let i = 0; i < visibleSymbolsCount; i++) {
            if (reelSymbols[i] == symbolId) {
                return i;
            }
        }

        return -1;
    }

    public static getNudgeSymbolFirstIndex(
        visibleSymbolsCount: number,
        currentSymbols: Array<Symbol>,
        symbolId: number,
    ): number {
        for (let i = 0; i < visibleSymbolsCount; i++) {
            if (currentSymbols[i].id + 1 == symbolId) {
                return i;
            }
        }

        return -1;
    }

    public static getNudgeSymbolStartIndex(firstIndex: number, count: number): number {
        if (firstIndex == 0) {
            return count - CustomUtils.NudgeSymbolPartCount;
        }

        return firstIndex;
    }

    public static getBlendMode(blendMode: number): number {
        if (Scaling.IsIOs) {
            if (blendMode == 1) {
                blendMode = 3;
            }
        }

        return blendMode;
    }

    public static updateSpineData(spineData: JSON): JSON {
        if (Scaling.IsIOs) {
            if (spineData != null) {
                let spineTextData = JSON.stringify(spineData);
                spineTextData = spineTextData.split('"blend":"additive"').join('"blend":"screen"');
                spineData = JSON.parse(spineTextData);
            }
        }

        return spineData;
    }

    public static hasCashWin(currentWins: IWin[]): boolean {
        let hasCashWin = false;

        if (!Utils.isNullOrUndefined(currentWins)) {
            for (let i = 0; i < currentWins.length; i++) {
                if (currentWins[i].trigger === Communication.Game.WinTrigger.Payline) {
                    if (currentWins[i].type == Communication.Game.WinType.Cash) {
                        hasCashWin = true;
                    }
                } else if (currentWins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                    if (currentWins[i].type == Communication.Game.WinType.Cash) {
                        hasCashWin = true;
                    }
                }
            }
        }
        return hasCashWin;
    }

    public static hasCopyWild(customData: any): boolean {
        if (!Utils.isNullOrUndefined(customData)) {
            if (customData.hasOwnProperty("wildSymbols")) {
                if (!Utils.isNullOrUndefined(customData.wildSymbols)) {
                    for (let j: number = 0; j < customData.wildSymbols.length; j++) {
                        if (customData.wildSymbols[j].type == "copy") {
                            return true;
                        }
                    }
                }
            }
        }

        return false;
    }

    public static hasExpandWild(response: GameModuleBaseResponse | GameModuleFreespinResponse): boolean {
        if (response.hasOwnProperty("screen")) {
            let reelsData = response.screen.reels;
            for (let reelIndex = 0; reelIndex < reelsData.length; reelIndex++) {
                if (
                    reelsData[reelIndex].transform &&
                    reelsData[reelIndex].symbols.indexOf(CustomUtils.SymbolWildExpand) !== -1
                ) {
                    return true;
                }
            }
        }

        return false;
    }

    public static hasMultiplyWild(response: GameModuleResponse): boolean {
        let customData = response.customData;
        if (!Utils.isNullOrUndefined(customData)) {
            if (customData.hasOwnProperty("wildSymbols")) {
                if (!Utils.isNullOrUndefined(customData.wildSymbols)) {
                    for (let j: number = 0; j < customData.wildSymbols.length; j++) {
                        if (customData.wildSymbols[j].type == "multiplier") {
                            return true;
                        }
                    }
                }
            }
        }

        return false;
    }

    /**
     *
     * @param objName
     * @param source
     * @param instanceType
     */
    public static getObjectFrom(objName: string, source: any, instanceType?: any): any {
        if (source != null) {
            let object: any;
            if (source instanceof SwitchElement) {
                object = source.getChildElementByName(objName);
            } else {
                object = source[objName];
            }

            if (object != null) {
                if (instanceType != null) {
                    if (object instanceof instanceType) {
                        return object;
                    } else {
                        if (DEBUG) {
                            CustomUtils.log("ERROR: " + objName + " has bad instance type");
                        }
                    }
                } else {
                    if (object) {
                        return object;
                    }
                }
            } else {
                if (DEBUG) {
                    CustomUtils.log("ERROR: no " + objName);
                }
            }
        }

        return null;
    }

    public static log(s: string): void {
        if (DEBUG) {
            let compName = (this as any).__componentName__;
            Logger.debugGroup(compName, s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/CustomUtils.ts
 **/